/*************************************************/
/* MENU                                          */
/*************************************************/

export function menu() {
    const menuButton = document.querySelector(".menu-nav-mobile__btn");
    const menu = document.querySelector(".menu-nav__wrap");
    const menuCloseButton = document.querySelector(".menu-nav__close");
    const firstFocusableElement = menu ? menu.querySelector('.menu-nav__link') : null;
    const body = document.body;

    const openMenuClass = "menu-nav__wrap-open";
    const noScrollClass = "no-scroll";
    const openSubMenuClass = 'is-open';

    const transitionDuration = 300;

    if (!menuButton || !menu || !firstFocusableElement || !menuCloseButton) {
        console.error("Menu, button or first focusable element not found.");
        return;
    }

    const openMenu = () => {
        menu.classList.add(openMenuClass);
        menuButton.setAttribute("aria-expanded", "true");
        menu.setAttribute("aria-hidden", "false");
        body.classList.add(noScrollClass);
    };

    const closeMenu = (returnFocus = true) => {
        menu.classList.remove(openMenuClass);
        body.classList.remove(noScrollClass);
        menuButton.setAttribute("aria-expanded", "false");
        menu.setAttribute("aria-hidden", "true");

        if (returnFocus) {
            menuButton.focus();
        }
    };

    const initAccordion = () => {
        const toggleSpans = document.querySelectorAll('.menu-nav__link--parent');

        toggleSpans.forEach(span => {
            const parentLink = span.closest('a.menu-nav__link');
            const parentListItem = parentLink ? parentLink.closest('li.menu-nav__item--parent') : null;
            const subMenu = parentListItem ? parentListItem.querySelector('.menu-nav--lvl-2') : null;

            const hrefValue = parentLink ? parentLink.getAttribute('href') : null;
            const disabledParentLink = !hrefValue || hrefValue.trim() === '' || hrefValue === '#';

            if (disabledParentLink) {
                parentLink.setAttribute('role', 'button');
            }

            if (!parentListItem || !subMenu) {
                console.warn("Accordion structure incomplete for a list item.");
                return;
            }

            parentLink.setAttribute('aria-expanded', 'false');

            const handleToggleAction = (event) => {
                event.stopPropagation();
                event.preventDefault();

                const isHidden = subMenu.getAttribute('aria-hidden') === 'true';

                subMenu.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
                parentLink.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
                parentListItem.classList.toggle(openSubMenuClass, isHidden);

                if (isHidden) {
                    subMenu.setAttribute('aria-hidden', 'false');
                    parentLink.setAttribute('aria-expanded', 'true');
                    parentListItem.classList.add(openSubMenuClass);
                    subMenu.style.maxHeight = (subMenu.scrollHeight + 30) + 'px';

                    const links = subMenu.querySelectorAll('.menu-nav__link');
                    links.forEach(link => link.setAttribute('tabindex', '0'));

                    // Close other open sub-menus
                    toggleSpans.forEach(otherSpan => {
                        if (otherSpan !== span) {
                            const otherListItem = otherSpan.closest('li.menu-nav__item--parent');
                            const otherListItemParent = otherSpan.closest(".menu-nav__link");
                            const otherSubMenu = otherListItem ? otherListItem.querySelector('.menu-nav--lvl-2') : null;

                            if (otherSubMenu && otherSubMenu.getAttribute('aria-hidden') === 'false') {
                                otherSubMenu.style.maxHeight = otherSubMenu.scrollHeight + 'px';
                                void otherSubMenu.offsetWidth; // Force reflow for smoothness
                                otherSubMenu.style.maxHeight = '0';
                                otherSubMenu.setAttribute('aria-hidden', 'true');
                                otherListItemParent.setAttribute('aria-expanded', 'false');
                                otherListItem.classList.remove(openSubMenuClass);
                                otherSubMenu.style.maxHeight = null;

                                const otherLinks = otherSubMenu.querySelectorAll('.menu-nav__link');
                                otherLinks.forEach(link => link.setAttribute('tabindex', '-1'));
                            }
                        }
                    });
                } else {
                    // Close logic
                    subMenu.style.maxHeight = (subMenu.scrollHeight + 30) + 'px';
                    void subMenu.offsetWidth; // Force reflow
                    subMenu.style.maxHeight = '0';

                    const links = subMenu.querySelectorAll('.menu-nav__link');
                    links.forEach(link => link.setAttribute('tabindex', '-1'));

                    setTimeout(() => {
                        subMenu.setAttribute('aria-hidden', 'true');
                        parentLink.setAttribute('aria-expanded', 'false');
                        parentListItem.classList.remove(openSubMenuClass);
                        subMenu.style.maxHeight = null;
                    }, transitionDuration);
                }
            };

            // Trigger logic if the parent link is clicked and is "disabled"
            parentLink.addEventListener('click', (event) => {
                if (disabledParentLink) {
                    handleToggleAction(event);
                }
            });

            // Trigger logic if the span is clicked
            span.addEventListener('click', (event) => {
                handleToggleAction(event);
            });

            parentLink.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    if (disabledParentLink) {
                        handleToggleAction(event);
                    }
                }
            });

            span.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    handleToggleAction(event);
                }
            });
        });
    };

    const init = () => {

        menu.addEventListener("keydown", e => {
            const isMenuOpen = menu.classList.contains(openMenuClass);
            if (e.key !== "Tab" || !isMenuOpen) return;

            // Get all currently visible focusable elements (including newly opened accordion links)
            const focusableElements = menu.querySelectorAll(
                'a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'
            );

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) { // If Shift + Tab
                if (document.activeElement === firstElement) {
                    lastElement.focus();
                    e.preventDefault();
                }
            } else { // If Tab
                if (document.activeElement === lastElement) {
                    firstElement.focus();
                    e.preventDefault();
                }
            }
        });

        menuButton.addEventListener("click", e => {
            e.stopPropagation();
            const isMenuOpen = menu.classList.contains(openMenuClass);

            if (isMenuOpen) {
                closeMenu();
            } else {
                openMenu();

                setTimeout(() => {
                    if (firstFocusableElement) {
                        firstFocusableElement.focus();
                    }
                }, 100);
            }
        });

        menuCloseButton.addEventListener("click", e => {
            e.stopPropagation();
            closeMenu();
        });

        // Click outside logic
        document.addEventListener("click", e => {
            const isMenuOpen = menu.classList.contains(openMenuClass);
            const isClickInsideMenu = menu.contains(e.target);
            const isClickOnButton = menuButton.contains(e.target);
            const isClickOnCloseButton = menuCloseButton.contains(e.target);

            if (isMenuOpen && !isClickInsideMenu && !isClickOnButton && !isClickOnCloseButton) {
                closeMenu();
            }
        });

        // Escape key logic
        document.addEventListener("keydown", e => {
            const isMenuOpen = menu.classList.contains(openMenuClass);

            if (isMenuOpen && e.key === "Escape") {
                closeMenu();
            }
        });

        initAccordion();
    };

    init();
}